import { render, staticRenderFns } from "./WDGMascot.vue?vue&type=template&id=45af5202&"
import script from "./WDGMascot.vue?vue&type=script&lang=js&"
export * from "./WDGMascot.vue?vue&type=script&lang=js&"
import style0 from "./WDGMascot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports